import React from "react";
import styles from "./ReadonlyTextarea.module.css";

export interface ReadonlyTextareaProps {
  value: string;
}

const ReadonlyTextarea = ({
  value
}: ReadonlyTextareaProps): React.ReactElement => {

  return (
    <textarea
      className={styles.readonlyTextarea}
      readOnly
      spellCheck={false}
      value={value}
      onChange={() => {}}
    />
  );
};

export default ReadonlyTextarea;
